// extracted by mini-css-extract-plugin
export default {"background":"Modal_background__TfJvi","modal":"Modal_modal__bJ72n","modalCloseButton":"Modal_modalCloseButton__OIUAi"};